import { styled } from 'styled-components';

const StyledPageHeader = styled.div<{ $description?: string }>`
  display: flex;
  align-items: flex-start;
  margin: 0 0 1.5rem 0;
  justify-content: space-between;
  flex-wrap: wrap;

  .title {
    font-family: var(--font-stack-segoe);
    font-weight: 600;
    color: var(--title-color);
    font-size: 2.2rem;
    line-height: 2rem;
    margin: ${(props) => (props.$description ? '0 0 0.5rem 0' : '0 0 1.5rem 0')};
    padding: 0;
  }

  .description {
    color: #57606a;
    padding: 0;
    font-size: 1.25rem;
    line-height: 1.5rem;
  }

  /* Landscape phones/portrait tables */
  @media (max-width: 768px) {
    flex-direction: column;
    .title {
      font-size: 2rem;
      line-height: 1.5rem;
    }

    .description {
      font-size: 1.15rem;
      line-height: 1.25rem;
    }
  }

  /* Portrait phones */
  @media (max-width: 475px) {
    .title {
      font-size: 1.7rem;
      line-height: 1.5rem;
    }

    .description {
      font-size: 1.1rem;
      line-height: 1.25rem;
    }
  }
`;

export { StyledPageHeader };
